import { render, staticRenderFns } from "./Pl3Add.vue?vue&type=template&id=6981fd81&"
import script from "./Pl3Add.vue?vue&type=script&lang=js&"
export * from "./Pl3Add.vue?vue&type=script&lang=js&"
import style0 from "./Pl3Add.vue?vue&type=style&index=0&id=6981fd81&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports